import { useState } from "react";
import { useTranslation } from "react-i18next";
import useTranslate from "../../../../../hooks/useTranslate";
import { RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES } from "../components/drawers";

const useResponsiblesModule = () => {
    const [selected, setSelected] = useState<null | any>(null);
    const [open, setOpen] = useState<string>('');
    const { t } = useTranslation('carcinogenicReport', {
        keyPrefix: 'modules.responsiblesAndContractors'
    });
    const { translate } = useTranslate(t);

    const handleEditNewContractorIconClick = (item: any) => {
        setSelected(item)
        setOpen(RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.NEW_CONTRACTOR);
    }

    const handleEditContractorIconClick = (item: any) => {
        setSelected(item);
        setOpen(RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.EDIT_CONTRACTOR);
    }

    const handleNewResponsibleIconClick = () => {
        setOpen(RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.NEW_RESPONSIBLE);
    };

    const handleEditResponsibleIconClick = (item: any) => {
        setSelected(item);
        setOpen(RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.EDIT_RESPONSIBLE);
    }

    return {
        selected,
        open,
        translate,
        setOpen,
        handleEditNewContractorIconClick,
        handleEditContractorIconClick,
        handleNewResponsibleIconClick,
        handleEditResponsibleIconClick
    };
}

export default useResponsiblesModule;